import clsx from 'clsx';
import React from 'react';

export interface RefusalReasonData {
  reason: string;
  percentage: number;
  color: string;
}

export interface RefusalReasonsListProps {
  title: string;
  data: RefusalReasonData[];
  className?: string;
}

export const RefusalReasonsList: React.FC<RefusalReasonsListProps> = ({
  title,
  data,
  className,
}) => {
  return (
    <div className={clsx('bg-white p-6 rounded-lg border-2 border-neutral-200', className)}>
      <h3 className="text-lg font-semibold text-neutral-800 mb-6">{title}</h3>

      <div className="space-y-4">
        {data.map((item, index) => (
          <div key={index}>
            <div className="flex items-center justify-between mb-2">
              <p className="text-sm text-neutral-600">{item.reason}</p>
              <span className="text-sm font-semibold text-neutral-800">
                {item.percentage}%
              </span>
            </div>
            <div className="bg-neutral-100 rounded-full h-2 overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{
                  width: `${String(item.percentage)}%`,
                  backgroundColor: item.color,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
